var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemaleNurse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.779 87.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Female_nurse-01",
    "data-name": "Female nurse-01",
    transform: "translate(-42.646 -34.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M58.1,76.9c-4.2,3.9-11.3,7.4-15.1,39.6L56.2,111,62,90.8Z",
    fill: "#2b5889",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M103.3,122.1a174.776,174.776,0,0,0-2.7-19.3c-.6-2.3-1.1-4.6-1.5-7.1A9.863,9.863,0,0,1,91,97.9l-1.2,5.4L95.3,122h8Z",
    fill: "#f7d9c1",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M89.3,107.2c2.8.7,11.5-3.3,11.9-5-2.5-10.8-4.8-21.5-10-25.4-2.1,4-5.3,7.1-3.8,15.8Z",
    fill: "#2b5889",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M59,106.1l-1.4,16H91.9l-1.5-15.9c5.5-8.7.4-17.2.4-17.2a67.5,67.5,0,0,1,.4-12.3C87,73.8,80.9,73,76.7,72.8h-4c-4.1.2-10.2,1-14.5,3.9A66.879,66.879,0,0,1,58.6,89,16.71,16.71,0,0,0,59,106.1Z",
    fill: "#2b5889",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M74.1,78h-.2c-2.4,0-4.3-.5-4.3-2.9V66.9a4.268,4.268,0,0,1,4.3-4.3h.2a4.268,4.268,0,0,1,4.3,4.3v8.2C78.5,77.5,76.5,78,74.1,78Z",
    fill: "#f7d9c1",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M78.4,70a7.652,7.652,0,0,1-4.3,1.3,7.879,7.879,0,0,1-4.4-1.2V71a9.471,9.471,0,0,0,4.4,1.7,8.227,8.227,0,0,0,4.3-1.8Z",
    fill: "#161b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M74.8,56.5l1.8,5.8a1.176,1.176,0,0,1-1.1,1.4H73.6",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M71.7,67.1s2.8,1.1,4.5-.2",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M83.7,109.6l-12.2-.3c-.2,0-.3-.2-.3-.4L71.8,86a.472.472,0,0,1,.5-.5l12.2.3c.2,0,.3.2.3.4l-.5,22.9A.634.634,0,0,1,83.7,109.6Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M83.6,109.8l-12.2-.3c-.2,0-.3-.2-.3-.4l.5-22.9a.472.472,0,0,1,.5-.5l12.2.3c.2,0,.3.2.3.4L84,109.3A.458.458,0,0,1,83.6,109.8Z",
    fill: "#161b43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M43.9,112.9A3.331,3.331,0,0,1,45,112l19.6-9.1a.367.367,0,0,1,.3-.1,4.61,4.61,0,0,0,1.8-2.7,8.179,8.179,0,0,1,2.4-3.6s1.7-2.8,2-1.9c0,0,.8,1.1,0,4.5l-.1.3s4.9,1.3,10.4-4.1c0,0,1.6.4-.2,3.3a4.729,4.729,0,0,1-2.1,4.6,6.092,6.092,0,0,1-4.7,4.7,25.466,25.466,0,0,0-5.8,1.5c-.1.3-.5.5-.8.7-3.8,3.7-16.4,15.4-22.9,10A5.347,5.347,0,0,1,43.9,112.9Z",
    fill: "#f7d9c1",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M71.4,99.4s-1.9-.5-2.8.8",
    fill: "#f7d9c1",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M81.2,98.5s-1.3,2.1-5.7,3.1",
    fill: "#f7d9c1",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M79,103.1s-.5,1.1-4.3,1.6",
    fill: "#f7d9c1",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M74.3,40.3c10.6.1,11.2,10.2,11.2,11.4v.2c-.1,1.1-.9,11.4-1.6,13.5-1.2,4.1-7.6,6.4-10,6.4-2.5,0-8.6-2-9.8-6.6-.6-2.2-1.6-12.4-1.7-13.5,0-.1.4-.1.4-.2C62.9,50.3,63.7,40.2,74.3,40.3Z",
    fill: "#f7d9c1",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M62.9,46.8H85.2a10.054,10.054,0,0,0,.4-2.5c0-5.5-5.2-9.9-11.7-9.9s-11.7,4.4-11.7,9.9a6.9,6.9,0,0,0,.4,2.5Z",
    fill: "#2c355e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M63.8,47.3a6.491,6.491,0,0,1,1.8,1.9,9.223,9.223,0,0,1,.5.8h0c.2,0,.3.1.5.1h.6c.1,0,.3-.1.4-.1a2.092,2.092,0,0,0,.6-.4c1.2-1,2.1-2.3,3.3-3.4a7.639,7.639,0,0,1,2.3-1.7,11.367,11.367,0,0,1,3.6-1c2.6-.3,4.5,1.7,5.8,3.7a3.137,3.137,0,0,1,2.3-1.7,5.12,5.12,0,0,0-.7-1c-11.8-13.1-21.9-.4-21.9-.4a14.592,14.592,0,0,0-1.6,3A2.726,2.726,0,0,1,63.8,47.3Z",
    fill: "#161b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M63.6,62.4s-7.9-8-1.4-17.4c0,0,10.7-12.6,23.3.5,0,0,6.4,6.6-1.1,17.2a16.051,16.051,0,0,1,.1-5.4,3.976,3.976,0,0,0-.9-3s-4.3-5.2-4.5-7.4c0,0-4.4,8.3-16.3,8.6Z",
    fill: "#2c355e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M74.9,56.5l1.8,5.8a1.176,1.176,0,0,1-1.1,1.4H73.7",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M71.8,67.1s2.8,1.1,4.5-.2",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M63,55.6c-1.1.4-1.6,1.9-1.1,3.5a3.25,3.25,0,0,0,1.9,2.3Z",
    fill: "#f7d9c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M84.2,55.4c1.1.3,1.7,1.8,1.4,3.4A3.572,3.572,0,0,1,84,61.3Z",
    fill: "#f7d9c1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleNurse);
export default __webpack_public_path__ + "static/media/female-nurse.e025d1af9f8ca5cac18e619b2958ab02.svg";
export { ForwardRef as ReactComponent };